module.exports = __webpack_public_path__ + "img/icon-angle-right.457071e9.svg";